/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Admin } from './Admin';
import {
    AdminFromJSON,
    AdminFromJSONTyped,
    AdminToJSON,
} from './Admin';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface AdminPagination
 */
export interface AdminPagination {
    /**
     * 
     * @type {Array<Admin>}
     * @memberof AdminPagination
     */
    data?: Array<Admin>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof AdminPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the AdminPagination interface.
 */
export function instanceOfAdminPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminPaginationFromJSON(json: any): AdminPagination {
    return AdminPaginationFromJSONTyped(json, false);
}

export function AdminPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AdminFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function AdminPaginationToJSON(value?: AdminPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AdminToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

